// extracted by mini-css-extract-plugin
export default {"notSetup":"notsetup_notSetup__xv3R1","enabled":"notsetup_enabled__NSiga"};